import React from "react";
import { Box, Typography } from "@mui/material";
import theme from "../../Theme";
import PastSimulationsCard from "../../components/complex/PastSimulationsCard";
import { BrandContext } from "../../App";

import PageTitle from "../../components/PageTitle/PageTitle";

export default function DashboardMarketing() {
  const { simulations } = React.useContext(BrandContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageTitle>Take a look below at your previous simulations</PageTitle>
      <Box>
        <PastSimulationsCard simulations={simulations.all} />
      </Box>
    </Box>
  );
}
